/* eslint-disable no-restricted-imports */
import { Box, Card, CardContent, Grid } from '@material-ui/core';

import { Skeleton } from '@mui/material';

export default function BudgetListSkeleton({ count = 5 }) {
  return (
    <Box display='flex' flexDirection='column' gap={2}>
      {Array.from({ length: count }).map((_, index) => (
        <Card key={index} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
          <CardContent style={{ padding: 16 }}>
            <Box>
              <Box
                display='flex'
                alignItems='flex-start'
                justifyContent='space-between'
                marginBottom={2}
                flexWrap='wrap'
                gap={1}
              >
                <Box flex={1} minWidth={150}>
                  <Skeleton variant='text' width='60%' height={24} />
                  <Skeleton variant='text' width='40%' height={16} style={{ marginTop: 4 }} />
                </Box>
                <Skeleton
                  variant='rectangular'
                  width={100}
                  height={24}
                  style={{ borderRadius: 12 }}
                />
              </Box>

              <Grid container spacing={2} marginBottom={2}>
                <Grid item xs={12} sm={6}>
                  <Box display='flex' alignItems='center' gap={1}>
                    <Skeleton variant='circular' width={24} height={24} />
                    <Box flex={1}>
                      <Skeleton variant='text' width='80%' height={18} />
                      <Skeleton variant='text' width='60%' height={14} style={{ marginTop: 4 }} />
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box display='flex' alignItems='center' gap={1}>
                    <Skeleton variant='circular' width={24} height={24} />
                    <Box flex={1}>
                      <Skeleton variant='text' width='90%' height={18} />
                      <Skeleton variant='text' width='70%' height={14} style={{ marginTop: 4 }} />
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box display='flex' alignItems='center' gap={1}>
                    <Skeleton variant='circular' width={24} height={24} />
                    <Box flex={1}>
                      <Skeleton variant='text' width='50%' height={14} />
                      <Skeleton variant='text' width='60%' height={18} style={{ marginTop: 4 }} />
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box>
                    <Skeleton variant='text' width='50%' height={14} />
                    <Skeleton variant='text' width='70%' height={28} style={{ marginTop: 4 }} />
                  </Box>
                </Grid>
              </Grid>

              <Box marginTop={2} paddingTop={2} borderTop='1px solid #f0f0f0'>
                <Skeleton variant='text' width='90%' height={14} style={{ marginBottom: 8 }} />
                <Box display='flex' alignItems='center' justifyContent='flex-end'>
                  <Skeleton variant='text' width={100} height={14} />
                </Box>
              </Box>
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}
